import React, { createContext, useContext, useState } from 'react';

interface NavigationContextProps {
  open: boolean;
  toggle(): void;
  setOpen(value: boolean): void;
  activeTab: number;
  setActiveTab(value: number): void;
  isInteractive: boolean;
}

export const NavigationContext = createContext<NavigationContextProps>({
  toggle: () => undefined,
  open: false,
  setOpen: () => undefined,
  activeTab: 0,
  setActiveTab: () => undefined,
  isInteractive: false,
});

const Provider = NavigationContext.Provider;

interface Props {
  children: React.ReactElement | React.ReactElement[];
}

export const NavigationProvider: React.FC<Props> = ({ children }) => {
  const [open, setOpenIntern] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<number>(0);
  const [isInteractive, setIsInteractive] = useState<boolean>(false);
  const toggle = () => {
    setIsInteractive(true);
    setOpenIntern((open) => !open);
  };

  const setOpen = (value: boolean) => {
    setIsInteractive(true);
    setOpenIntern(value);
  };

  return <Provider value={{ open, toggle, setOpen, activeTab, setActiveTab, isInteractive }}>{children}</Provider>;
};

export const useNavigation = (): NavigationContextProps => {
  const navigation = useContext(NavigationContext);

  if (!navigation) {
    throw Error('The `useNavigation` hook must be called from a descendent of the `NavigationProvider`.');
  }

  return {
    ...navigation,
  };
};
